import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import useProductAttributes from 'data-hooks/useProductAttributes/index';
import PDPInfoTable from '../PDPInfoTable';
import PDPMeasureForDeliverySlideshow from '../PDPMeasureForDeliverySlideshow';
import PDPInfoSectionLayout from './PDPInfoSectionLayout';
import PDPInfoSegmentedTabs from './PDPInfoSegmentedTabs';
const PRODUCT_SUB_TAB_ID = 'pdp-info-dimensions-product';
const SHIPPING_SUB_TAB_ID = 'pdp-info-dimensions-shipping';

// Dimensions tab: the measurement tables on the left, Measuring for Delivery on the right
const PDPInfoDimensionsSection = t0 => {
  const $ = _c(12);
  const {
    stacked: t1
  } = t0;
  const stacked = t1 === undefined ? false : t1;
  const [chosenSubTab, setChosenSubTab] = useState(PRODUCT_SUB_TAB_ID);
  const {
    error,
    data: t2
  } = useProductAttributes();
  const {
    dimensions,
    boxDimensions
  } = t2;
  if (error) {
    return null;
  }
  const hasProductDimensions = dimensions?.length > 0;
  const hasBoxDimensions = boxDimensions?.length > 0;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <><PDPMeasureForDeliverySlideshow /><Link className="inline-block mt-4 text-xs font-bold text-brand no-underline hover:cursor-pointer hover:underline" to="/fit-guide" target="_blank">Measure for delivery</Link></>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const aside = t3;
  let t4;
  if ($[1] !== dimensions) {
    t4 = <PDPInfoTable items={dimensions} />;
    $[1] = dimensions;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const productTable = t4;
  let t5;
  if ($[3] !== boxDimensions) {
    t5 = <PDPInfoTable items={boxDimensions} />;
    $[3] = boxDimensions;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const boxTable = t5;
  let t6;
  if ($[5] !== boxTable || $[6] !== chosenSubTab || $[7] !== hasBoxDimensions || $[8] !== hasProductDimensions || $[9] !== productTable || $[10] !== stacked) {
    t6 = <PDPInfoSectionLayout aside={aside} asideHeading="Measuring for Delivery">{!stacked && hasProductDimensions && hasBoxDimensions ? <PDPInfoSegmentedTabs aria-label="Dimensions" items={[{
        id: PRODUCT_SUB_TAB_ID,
        label: "Dimensions",
        content: productTable
      }, {
        id: SHIPPING_SUB_TAB_ID,
        label: "Shipping Dimensions",
        content: boxTable
      }]} selectedTab={chosenSubTab} onSelectTab={setChosenSubTab} /> : <>{hasProductDimensions && productTable}{hasBoxDimensions && <div className={hasProductDimensions ? "[border-top:1px_solid_#e5e5e5] mt-8 pt-8" : undefined}><h4 className="text-base font-bold text-gray m-0">Shipping Dimensions</h4>{boxTable}</div>}</>}</PDPInfoSectionLayout>;
    $[5] = boxTable;
    $[6] = chosenSubTab;
    $[7] = hasBoxDimensions;
    $[8] = hasProductDimensions;
    $[9] = productTable;
    $[10] = stacked;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
PDPInfoDimensionsSection.propTypes = {
  stacked: PropTypes.bool
};
export default PDPInfoDimensionsSection;